import { render, staticRenderFns } from "./IconPinterest.vue?vue&type=template&id=48acd6e0&"
import script from "./IconPinterest.vue?vue&type=script&lang=js&"
export * from "./IconPinterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports